import { Plus } from 'lucide-react'

import { useState } from 'react'

import { Button } from '@/components/ui/button'
import { Card, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'

import { PageHeader } from '@/components/atoms'
import { TaxClasses } from '@/components/taxes/TaxClasses'
import { TaxExemptions } from '@/components/taxes/TaxExemptions'
import { TaxRates } from '@/components/taxes/TaxRates'
import { TaxReports } from '@/components/taxes/TaxReports'

import { useBusiness } from '@/contexts/BusinessContext'

export const TaxDashboard = () => {
  const [activeTab, setActiveTab] = useState('rates')
  const { formatCurrency } = useBusiness()

  // Mock stats - replace with actual data
  const stats = {
    totalRates: 15,
    totalClasses: 4,
    totalCollected: 45680.5,
    averageRate: 7.5,
  }

  return (
    <div className="space-y-4">
      <PageHeader
        size="large"
        title="Taxes"
        actions={
          <>
            {activeTab === 'rates' && (
              <Button>
                <Plus />
                Add tax rate
              </Button>
            )}
            {activeTab === 'classes' && (
              <Button>
                <Plus />
                Add tax class
              </Button>
            )}
            {activeTab === 'exemptions' && (
              <Button>
                <Plus />
                Add exemption
              </Button>
            )}
          </>
        }
      />

      <Card className="overflow-hidden">
        <CardHeader className="pb-2">
          <CardTitle>Tax rates and rules</CardTitle>
          <CardDescription>
            {stats.totalRates} rates, {stats.totalClasses} classes, average rate {stats.averageRate.toFixed(1)}%,{' '}
            {formatCurrency(stats.totalCollected)} collected this month
          </CardDescription>
        </CardHeader>
        <Tabs value={activeTab} onValueChange={setActiveTab}>
          <div className="no-scrollbar overflow-x-auto px-2 pb-2">
            <TabsList>
              <TabsTrigger value="rates">Rates</TabsTrigger>
              <TabsTrigger value="classes">Classes</TabsTrigger>
              <TabsTrigger value="reports">Reports</TabsTrigger>
              <TabsTrigger value="exemptions">Exemptions</TabsTrigger>
            </TabsList>
          </div>

          <TabsContent value="rates" className="mt-0">
            <TaxRates />
          </TabsContent>

          <TabsContent value="classes" className="mt-0">
            <TaxClasses />
          </TabsContent>

          <TabsContent value="reports" className="mt-0">
            <TaxReports />
          </TabsContent>

          <TabsContent value="exemptions" className="mt-0">
            <TaxExemptions />
          </TabsContent>
        </Tabs>
      </Card>
    </div>
  )
}
